import { ChangeDetectorRef, Component} from '@angular/core';
import { ExpressyonService } from 'app/expressyon.service';
import { Network } from '@capacitor/network';

@Component({
  selector: 'app-connection',
  templateUrl: './connection.component.html',
  styleUrls: ['../app.component.scss'],
})

export class ConnectionComponent {

  limitedNetwork: boolean;
  online: boolean;
  isWeb: boolean;
  
  constructor(private expressyonService: ExpressyonService, private changeDetector : ChangeDetectorRef) {
    this.limitedNetwork = !this.expressyonService.getConnected();
    this.online = this.expressyonService.getNetworkStatus();
    this.isWeb = this.expressyonService.getIsWeb();

    this.expressyonService.networkStatusChange.subscribe(value => {
      this.online = value;
      this.changeDetector.detectChanges();
    });

    this.expressyonService.isConnectedChange.subscribe(value => {
      this.limitedNetwork = !value;
      this.changeDetector.detectChanges();
    });
  }

  ngAfterViewInit() {
    // Checking if services are availables
    Network.getStatus().then(status => {
      if(!this.expressyonService.setNetworkStatus(status.connected)) {
        this.expressyonService.sendInfos(false);
      }
    })
  }
  
}